/**
 * Format a picked Date as the calendar day the user actually chose.
 *
 * `date.toISOString().split('T')[0]` is the obvious thing to write and is
 * wrong everywhere east of UTC. A DatePicker hands back local midnight, and
 * toISOString converts to UTC first — so in Lagos (UTC+1) 7 August 00:00
 * becomes `2026-08-06T23:00:00Z` and the date silently arrives a day early.
 * For attendance that means a register saved against yesterday.
 *
 * Reading the local components instead keeps the day the user pointed at.
 */
export function toDateOnly(date: Date | null | undefined): string {
  if (!date) return '';

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
}
